export const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://www.monyawn.com").replace(
  /\/$/,
  "",
);

export const BRAND_NAME = "Monyawn";
export const BRAND_TAGLINE = "Local-first AI-native opportunity management";
export const BRAND_DESCRIPTION =
  "Monyawn is a local-first, AI-native opportunity management platform that turns high-stakes career moves into evidence-backed workflows with private-by-default data handling.";

export const ORGANIZATION_NAME = "Monyawn";
export const ORGANIZATION_LEGAL_NAME = "CAD Guardian LLC";
export const FOUNDER_NAME = "Thomas Smith";

export const SOCIAL_PROFILES = [
  "https://github.com/cadguardianllc/sbs_opportunity_management_panel",
];

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-preview.png`;

export const SUPPORT_CONTACT_PATH = "/support";

export function toAbsoluteUrl(path: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (!path.startsWith("/")) return `${SITE_URL}/${path}`;
  return `${SITE_URL}${path}`;
}
